import { render, staticRenderFns } from "./Interests.vue?vue&type=template&id=645f9ea4&scoped=true&"
import script from "./Interests.vue?vue&type=script&lang=js&"
export * from "./Interests.vue?vue&type=script&lang=js&"
import style0 from "./Interests.vue?vue&type=style&index=0&id=645f9ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f9ea4",
  null
  
)

export default component.exports